import { Component, OnInit, ViewChild } from '@angular/core';
import { TabsetComponent, BsModalRef, BsModalService } from 'ngx-bootstrap';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { GeneralService } from 'src/app/services/general.service';
import { DataService } from '../../services/data.service';
import { ModalSuccesEnjoyClComponent } from '../modal-succes-enjoy-cl/modal-succes-enjoy-cl.component';
import { Util } from '../../utils/functions';
import { Subscription } from 'rxjs/internal/Subscription';
import { Unidad } from 'src/app/models/unidad';
import { Router } from '@angular/router';
import { NgxSpinnerService } from "ngx-spinner";


@Component({
    selector: 'app-cotizacion',
    templateUrl: './cotizacion.component.html',
    styleUrls: ['./cotizacion.component.scss']
})
export class CotizacionComponent implements OnInit {

    @ViewChild('staticTabs') staticTabs: TabsetComponent;
    frmCotizacionStep1: FormGroup;
    frmCotizacionStep2: FormGroup
    unidades: any;
    url: string = '';
    idIdioma: string = '';
    subscription: Subscription;
    tipoCotizacion: any = [];
    tipoEvento: any = [];
    salones: any = [];
    unidadSelected: Unidad;
    capacidadEvento: any = [];
    // Datepicker
    minDate = new Date();
    bsConfig = {
        showWeekNumbers: false,
        dateInputFormat: 'DD-MM-YYYY'
    };
    
    ruta: any = [];
    // MODAL
    bsModalRef: BsModalRef;
    config = {
        backdrop: true,
        ignoreBackdropClick: true
    };
    
    emailRegEx = '^[a-zA-Z0-9\._+-]+@[\da-zA-Z_-]{2,25}[\.]{1}[a-zA-Z]{2,6}$';
    lettersRegEx = '^[a-zÀ-ÿñÑA-Z-,\´]+\s{0,1}[a-zÀ-ÿñÑA-Z-, \´]*$';
    lettersRegEx2 = '^[0-9a-zñÑA-Z]+$';

    constructor(
        private dataService: DataService,
        private fb: FormBuilder,
        private generalService: GeneralService,
        private modalService: BsModalService,
        private router: Router,
        private spinner: NgxSpinnerService
    ) { }

    ngOnInit() {
        this.dataService.currentUrl.subscribe(url => {
            this.ruta = url.split('/');
            switch (this.ruta[2]) {
                case 'eventos': {
                    this.generalService.generaObjetoEmail('EVE');
                    break;
                }
                case 'centro-de-negocios': {
                    this.generalService.generaObjetoEmail('NEG');
                    break;
                }
            }
            this.url = url;
        });

        this.dataService.currentUnidades.subscribe(unidades => this.unidades = unidades);
        this.dataService.currentUnidadSelected.subscribe(unidadSelected => {
            this.unidadSelected = unidadSelected;
        }
        );
        
        this.subscription = this.dataService.$idioma.subscribe(value => {
            this.idIdioma = value;
            if (this.url.includes('cotizacion')) {
                this.selectListForm();
                this.formCotizacionStep1();
                this.formCotizacionStep2();
            }
        })
    }

    formCotizacionStep1() {
        this.frmCotizacionStep1 = this.fb.group({
            nombre: ['', [Validators.required, Validators.pattern(this.lettersRegEx)]],
            apellidos: ['', [Validators.required, Validators.pattern(this.lettersRegEx)]],
            rut: ['', [Validators.required, Validators.pattern(this.lettersRegEx2)]],
            email: ['', [Validators.required, Validators.pattern(this.emailRegEx)]],
            telefono: ['', Validators.required],
            cotizarComo: ['', Validators.required],
        });
    }
    formCotizacionStep2() {
        this.frmCotizacionStep2 = this.fb.group({
            unidad: ['', Validators.required],
            fecha: ['', [Validators.required]],
            tipoEvento: ['', Validators.required],
            salon: ['', Validators.required],
            capacidad: ['', Validators.required],
            comentario: ['', Validators.required]
        });
    }


    async selectListForm() {
        const idIdioma = await Util.getIdIdioma(this.idIdioma);
        this.generalService.contenidoFormularioCotizacion(this.unidadSelected.idUnidad, idIdioma)
            .subscribe(result => {
                if (result['codigo'] === 1) {
                    this.tipoCotizacion = result['data'].cotizarComo;
                    this.tipoEvento = result['data'].tipoDeEvento;
                    this.salones = result['data'].salon;
                    this.capacidadEvento = result['data'].capacidadDelEvento;
                }
                if (result['codigo'] === 2) {

                }
                if (result['codigo'] === 3) {

                }
            })
    }

    selectTab(tabId: number) {
        this.staticTabs.tabs[tabId].active = true;
    }

    sendCotizacion() {
        this.spinner.show();
        let objetoFormulario = [];
        let objetoSendMail = [];
        this.generalService.generaObjetoIdUnidad(this.unidadSelected['idUnidad']);
        objetoFormulario = this.generalService.clonaCampoFormulario(this.frmCotizacionStep1.value);
        objetoSendMail = this.generalService.preparaParamsEnvioEmail(objetoFormulario);
        objetoFormulario = this.generalService.clonaCampoFormulario(this.frmCotizacionStep2.value);
        const fecha = this.generalService.FechaFormatoDMY(this.frmCotizacionStep2.value.fecha);
        objetoFormulario['fecha'] = fecha;
        objetoSendMail = this.generalService.preparaParamsEnvioEmail(objetoFormulario);
        this.generalService.enviarCorreo(objetoSendMail).subscribe(resSendMail => {
            if (resSendMail['codigo'] === 1) {
                this.spinner.hide();
                this.bsModalRef = this.modalService.show(ModalSuccesEnjoyClComponent, this.config);
                this.bsModalRef.content.passEntry.subscribe((receivedEntry) => {
                    console.log('receivedEntry', receivedEntry);
                    objetoFormulario = [];
                    objetoSendMail = [];
                    this.generalService.clearObjetEmail();
                    const unidad = Util.eliminarDiacriticos(this.unidadSelected.nombre.toLowerCase().replace(/[' ']+/g, '-'));
                    this.router.navigate([`/${unidad}/centro-de-negocios/`]);
                });
            }
        });
        
        this.frmCotizacionStep1.reset();
        this.frmCotizacionStep2.reset();
        this.frmCotizacionStep1.get('cotizarComo').setValue('');
        this.frmCotizacionStep2.get('unidad').setValue('');
        this.frmCotizacionStep2.get('tipoEvento').setValue('');
        this.frmCotizacionStep2.get('salon').setValue('');
        this.frmCotizacionStep2.get('capacidad').setValue('');
        objetoFormulario = [];
        objetoSendMail = [];
        
    }

}
